import React from 'react';
import { Star, Quote } from 'lucide-react';
import { testimonials } from '../data/testimonials';

export const Testimonials = () => {
  return (
    <section id="reviews" className="py-24 bg-white" data-testid="testimonials-section">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="mb-14 flex flex-col md:flex-row md:items-end md:justify-between gap-6">
          <div>
            <span className="font-display uppercase tracking-[0.25em] text-sm font-semibold text-red-600">Reviews</span>
            <h2 className="font-display italic uppercase text-4xl md:text-5xl font-extrabold text-neutral-950 mt-2 mb-3">
              What Our Customers Say
            </h2>
            <p className="text-neutral-600 text-base md:text-lg">
              Real reviews from satisfied clients across Albuquerque & Los Lunas
            </p>
          </div>
          <div className="inline-flex items-center gap-2 bg-neutral-950 text-white px-5 py-3 rounded-sm w-fit" data-testid="five-star-badge">
            <Star className="w-5 h-5 fill-red-600 text-red-600" />
            <span className="font-display uppercase tracking-wider font-bold">5-Star Rated Service</span>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {testimonials.map((testimonial) => (
            <div
              key={testimonial.id}
              data-testid={`testimonial-${testimonial.id}`}
              className="relative bg-white border border-neutral-200 border-l-4 border-l-red-600 rounded-sm p-8 shadow-sm hover:shadow-lg hover:shadow-neutral-900/5 transition-shadow duration-300"
            >
              <Quote className="absolute top-6 right-6 w-8 h-8 text-neutral-200" />
              <div className="mb-4">
                <h3 className="font-display uppercase text-xl font-bold text-neutral-950 mb-2">{testimonial.name}</h3>
                <div className="flex gap-1">
                  {[...Array(testimonial.rating)].map((_, starIndex) => (
                    <Star key={`${testimonial.id}-star-${starIndex}`} className="w-5 h-5 fill-red-600 text-red-600" />
                  ))}
                </div>
              </div>
              <p className="text-neutral-700 leading-relaxed italic">&ldquo;{testimonial.review}&rdquo;</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
